import { useState } from 'react';
import { lumi } from '../lib/lumi';
import toast from 'react-hot-toast';

const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();

    if (!isValidEmail(trimmed)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    try {
      const result: any = await lumi.functions.invoke('subscribeNewsletter', {
        method: 'POST',
        body: {
          email: trimmed,
          source: 'home_newsletter',
        },
      });

      if (result?.error) {
        throw new Error(result.error);
      }

      setIsSuccess(true);
      setEmail('');
      toast.success('Thank you for joining!');
    } catch (error: any) {
      console.error('Newsletter subscription failed:', error);
      toast.error(error?.message || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-14 sm:py-20 md:py-24 px-4 sm:px-6 bg-[#722F37]">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-['EB_Garamond'] text-3xl sm:text-4xl md:text-5xl font-bold text-[#FAF9F6] mb-4 sm:mb-6">
          Stay Close to the Journey
        </h2>
        <p className="text-base sm:text-lg text-[#FAF9F6]/80 mb-8 leading-relaxed">
          Be the first to see new paintings, glimpses from the studio, and quiet moments of the creative process — straight to your inbox.
        </p>

        {isSuccess ? (
          <p className="text-[#FAF9F6] font-medium text-lg">Thank you — you're on the list.</p>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-stretch gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              disabled={isSubmitting}
              className="flex-1 px-4 py-3 border border-[#FAF9F6]/30 bg-white text-[#2C2C2C] placeholder:text-[#2C2C2C]/40 focus:outline-none focus:border-[#8C6D3F] transition-colors"
              aria-label="Email address"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-3 min-h-[48px] bg-[#8C6D3F] text-white font-medium hover:bg-[#6B4E2E] transition-all duration-300 disabled:opacity-60"
            >
              {isSubmitting ? 'Joining...' : 'Join'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;
